import React from 'react';
import Dropzone, { Accept } from 'react-dropzone';

interface Props {
  accept: Accept;
  label?: string;
  multiple?: boolean;
  onDrop: (acceptedFiles: File[]) => void;
}

export default function FileDropzone({
  accept,
  label = "Drag 'n' drop some files here, or click to select files",
  multiple = false,
  onDrop
}: Props) {
  return (
    <Dropzone accept={accept} multiple={multiple} onDrop={onDrop}>
      {({getRootProps, getInputProps}) => (
        <section className='FileDropzone'>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <p>{ label }</p>
          </div>
        </section>
      )}
    </Dropzone>
  );
}
